import { mdiMap } from '@mdi/js'

export default {
  title: 'Regency',
  to: 'regencies-list',
  icon: mdiMap,
  resource: 'RegenciesAdmin',
  action: 'read',
}
